import { createStore } from 'vuex';

export default createStore({
    state: {
        carts_count: 0,        
        empresaweb: '',
        theater_name: '',
        kiosk_name: '',
        view_cart: false,
        dialog_cart: true,
        globalTimeOut: 0,
        globalMaxTimeKiosk: 10,
        globalTimeoutCompletePurchase: 0,
    },
    mutations: {
    },
    actions: {
    },
});